import { Button, IconButton, Stack, useTheme } from 'ui';
import { CameraEnhance, Close } from 'ui/icons';

import { LANDSCAPE_CAMERA_HEADER_WIDTH, PORTRAIT_CAMERA_HEADER_HEIGHT, relativeZIndex } from '../../config';

export const CameraHeader = ({
  autoCapturing,
  toggleAutoCapture,
  handleStopCamera,
  isPortrait,
}: {
  autoCapturing: boolean;
  toggleAutoCapture: () => void;
  handleStopCamera: () => void;
  isPortrait: boolean;
}) => {
  const theme = useTheme();

  const getAutoCaptureButtonContent = () => {
    if (!isPortrait) {
      return <CameraEnhance />;
    }

    return autoCapturing ? 'On' : 'Off';
  };

  return (
    <Stack
      position="fixed"
      display="flex"
      height={isPortrait ? PORTRAIT_CAMERA_HEADER_HEIGHT : '100%'}
      flexDirection={isPortrait ? 'row' : 'column-reverse'}
      justifyContent="space-between"
      paddingTop={isPortrait ? 1 : 2}
      paddingBottom={isPortrait ? 1 : 2}
      paddingLeft={isPortrait ? 2 : 1}
      paddingRight={isPortrait ? 2 : 1}
      width={isPortrait ? '100%' : LANDSCAPE_CAMERA_HEADER_WIDTH}
      marginBottom={isPortrait ? 'auto' : undefined}
      sx={{
        zIndex: theme.zIndex.modal + relativeZIndex.toggleCameraButton,
      }}
    >
      <IconButton
        onClick={handleStopCamera}
        sx={{
          ':hover': {
            backgroundColor: theme.palette.secondary.main,
          },
          backgroundColor: theme.palette.secondary.main,
          zIndex: theme.zIndex.modal + relativeZIndex.toggleCameraButton,
        }}
      >
        <Close sx={{ color: theme.palette.common.white }} />
      </IconButton>

      <Button
        startIcon={isPortrait ? <CameraEnhance /> : null}
        variant={autoCapturing ? 'primary' : 'secondary'}
        onClick={toggleAutoCapture}
        sx={{
          zIndex: theme.zIndex.modal + relativeZIndex.toggleCameraButton,
        }}
      >
        {getAutoCaptureButtonContent()}
      </Button>
    </Stack>
  );
};
